import LogoSvg from '@/assets/wntd-wordmark-orange.svg';

interface CollectionShareCardProps {
  title: string;
  images?: string[];
  subtitle?: string; // Item count
}

export function CollectionShareCard({ title, images, subtitle }: CollectionShareCardProps) {
  const displayImages = images?.slice(0, 4) || [];
  
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#0a0a0a',
        padding: '48px 48px 40px',
      }}
    >
      {/* Cover grid */}
      <div
        style={{
          flex: 1,
          position: 'relative',
          borderRadius: 32,
          overflow: 'hidden',
        }}
      >
        {displayImages.length > 0 ? (
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gridTemplateRows: '1fr 1fr',
              gap: 4,
            }}
          >
            {displayImages.map((img, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: '#1a1a1a',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={img}
                  alt={`Item ${index + 1}`}
                  crossOrigin="anonymous"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            ))}
            {/* Fill remaining slots with empty divs */}
            {Array.from({ length: Math.max(0, 4 - displayImages.length) }).map((_, index) => (
              <div
                key={`empty-${index}`}
                style={{
                  backgroundColor: '#1a1a1a',
                }}
              />
            ))}
          </div>
        ) : (
          <div
            style={{
              width: '100%',
              height: '100%',
              background: 'linear-gradient(135deg, #FF5C4D 0%, #FF6F3B 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span
              style={{
                fontSize: 120,
              }}
            >
              📁
            </span>
          </div>
        )}
        
        {/* Gradient overlay */}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 300,
            background: 'linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0) 100%)',
          }}
        />
        
        {/* Collection info overlay */}
        <div
          style={{
            position: 'absolute',
            bottom: 40,
            left: 40,
            right: 40,
          }}
        >
          <h2
            style={{
              fontSize: 48,
              fontWeight: 700,
              color: 'white',
              lineHeight: 1.2,
              marginBottom: 12,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {title}
          </h2>
          {subtitle && (
            <p
              style={{
                fontSize: 28,
                fontWeight: 500,
                color: 'rgba(255,255,255,0.7)',
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* Footer with branding */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: 40,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <img
            src={LogoSvg}
            alt="WNTD"
            style={{ height: 36 }}
          />
          <span
            style={{
              fontSize: 24,
              color: 'rgba(255,255,255,0.5)',
              fontWeight: 500,
            }}
          >
            Collection on WNTD
          </span>
        </div>
        <span
          style={{
            fontSize: 24,
            color: 'rgba(255,255,255,0.4)',
            fontWeight: 400,
          }}
        >
          wntd.ai
        </span>
      </div>
    </div>
  );
}
